import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const PIN_KEY = 'WallBuiler::Pin';

const getDefaultState = () => ({
  pinned: window.localStorage.getItem(PIN_KEY) === '1'
});

const pin = createReducer(getDefaultState(), {
  [Constants.pin.toggle]: (state) => ({
    pinned: !state.pinned
  })
});

export default pin;
